import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { redpacketPlatformLedgerDataProvider } from './dataProvider';

export function initSocialTradingRedpacketPlatformLedgerDataProvider() {
  registerModuleDataProvider(
    Resources.socialTradingRedpacketPlatformLedger,
    redpacketPlatformLedgerDataProvider
  );
}

initSocialTradingRedpacketPlatformLedgerDataProvider();
